import { lazy } from 'react';

// project import
import MainLayout from 'layout/app/mantis';
import Loadable from 'layout/mantis/components/Loadable';
import AuthGuard from 'layout/mantis/utils/route-guard/AuthGuard';
import CommonLayout from '../layout/website/mantis';

const ListCustomEmailTemplates = Loadable(lazy(() => import('modules/settings/templates/custom_email_template/ListCustomEmailTemplates')));
const ListFeedbackSessions = Loadable(lazy(() => import('modules/core/feedback_session/ListFeedbackSessions')));
const FeedbackReviewSystemReport = Loadable(
	lazy(() => import('modules/core/report/feedback_review_system_report/FeedbackReviewSystemReport'))
);
const BatchParticipantCourseProgressStats = Loadable(
	lazy(() => import('modules/core/report/batch_participant_course_progress_report/BatchParticipantCourseProgressStats'))
);
const TrainerReportAllTimeWrapper = Loadable(lazy(() => import('modules/core/report/trainer_report_all_time/TrainerReportAllTimeWrapper')));
const ListExamQuestionTemplates = Loadable(
	lazy(() => import('modules/settings/templates/exam_question_template/ListExamQuestionTemplates'))
);
const ListFeedbackReviewSystems = Loadable(lazy(() => import('modules/core/feedback_review_system/ListFeedbackReviewSystems')));
const ListCompanySummaryReport = Loadable(lazy(() => import('modules/core/report/company_summary_report/ListCompanySummaryReport')));
const ListBatchAssessmentCriteriaTemplates = Loadable(
	lazy(() => import('modules/settings/templates/batch_assessment_criteria_template/ListBatchAssessmentCriteriaTemplates'))
);
const ListBatchScheduleTemplates = Loadable(
	lazy(() => import('modules/settings/templates/batch_schedule_template/ListBatchScheduleTemplates'))
);
const ViewBatch = Loadable(lazy(() => import('modules/core/view_batch/ViewBatch')));
const ViewAttendanceQR = Loadable(lazy(() => import('modules/core/attendance/ViewAttendanceQR')));
const ScanAttendanceQR = Loadable(lazy(() => import('modules/core/attendance/ScanAttendanceQR')));
const CourseChapterViewSimple = Loadable(lazy(() => import('modules/core/course/subModules/course_chapter/CourseChapterViewSimple')));

const ExamReport = Loadable(lazy(() => import('modules/core/report/exam_report/ExamReport')));
const BatchAssessmentReport = Loadable(lazy(() => import('modules/core/report/batch_assessment_report/BatchAssessmentReport')));
const FeedbackReportCollection = Loadable(lazy(() => import('modules/core/report/feedback_report_collection/FeedbackReportCollection')));

const ViewBatchRecord = Loadable(lazy(() => import('modules/core/batch/ViewBatchRecord')));

const TermsServiceAr = Loadable(lazy(() => import('modules/oauth/Register/TermsServiceAr')));
const TermsServiceEn = Loadable(lazy(() => import('modules/oauth/Register/TermsServiceEn')));
const PrivacyPolicyAr = Loadable(lazy(() => import('modules/oauth/Register/PrivacyPolicyAr')));
const PrivacyPolicyEn = Loadable(lazy(() => import('modules/oauth/Register/PrivacyPolicyEn')));

const Page404 = Loadable(lazy(() => import('layout/mantis/pages/maintenance/404')));
const Page500 = Loadable(lazy(() => import('layout/mantis/pages/maintenance/500')));
const PageComingSoon = Loadable(lazy(() => import('layout/mantis/pages/maintenance/coming-soon')));
const PageUnderConstruction = Loadable(lazy(() => import('layout/mantis/pages/maintenance/under-construction')));

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('modules/dashboard/default')));
const ChangePasswordWrapper = Loadable(lazy(() => import('modules/oauth/changePassword/ChangePasswordWrapper')));
const ChangeRecordWrapper = Loadable(lazy(() => import('modules/oauth/changeRecord/ChangeRecordWrapper')));

//Reports

const LearnerOverallReport = Loadable(lazy(() => import('modules/core/report/user_report/learner/learner_overall/LearnerOverallReport')));
const LearnerIndividualReport = Loadable(
	lazy(() => import('modules/core/report/user_report/learner/learner_individual/LearnerIndividualReport'))
);
const CpdRecordReport = Loadable(lazy(() => import('modules/core/report/cpd_record_report/CpdRecordReport')));
const CpdRecord = Loadable(lazy(() => import('modules/core/report/cpd_record/CpdRecord')));
const CertificateReport = Loadable(lazy(() => import('modules/core/report/certificate_report/CertificateReport')));
const CertificateVerify = Loadable(lazy(() => import('modules/core/report/certificate_verify/CertificateVerify')));
const CertificateMissing = Loadable(lazy(() => import('modules/core/report/certificate_missing/CertificateMissing')));
const FeedbackReport = Loadable(lazy(() => import('modules/core/report/feedback_report/FeedbackReport')));
const TrainerReport = Loadable(lazy(() => import('modules/core/report/trainer_report/TrainerReport')));
const AttendanceReport = Loadable(lazy(() => import('modules/core/report/attendance_report/AttendanceReport')));

const SupportReport = Loadable(lazy(() => import('modules/core/report/support_report/SupportReport')));

const CourseChapterView = Loadable(lazy(() => import('modules/core/course/subModules/course_chapter/CourseChapterView')));
const CourseUnitView = Loadable(lazy(() => import('modules/core/course/subModules/course_unit/CourseUnitView')));
const CourseDetail = Loadable(lazy(() => import('modules/core/course/subModules/course_view/CourseDetail')));
const CourseView = Loadable(lazy(() => import('modules/core/course/subModules/course_view/CourseView')));
const ListManageCourses = Loadable(lazy(() => import('modules/core/manage_course/ListCourses')));
const ListCourses = Loadable(lazy(() => import('modules/core/course/ListCourses')));
const ListMyCourses = Loadable(lazy(() => import('modules/core/course/ListMyCourses')));
const ManageCourse = Loadable(lazy(() => import('modules/core/manage_course/ManageCourse')));

const ListQuestions = Loadable(lazy(() => import('modules/core/exam/bank/ListQuestions')));
const ListExams = Loadable(lazy(() => import('modules/core/exam/generate/ListExams')));
const ListRetakeExams = Loadable(lazy(() => import('modules/core/exam/retake/ListRetakeExams')));

const ListAssignments = Loadable(lazy(() => import('modules/core/assignment/bank/ListAssignments')));
const ListBatchAssignments = Loadable(lazy(() => import('modules/core/assignment/generate/ListBatchAssignments')));
const TakeAssignment = Loadable(lazy(() => import('modules/core/assignment/generate/submodules/batch_assignment_attempt/TakeAssignment')));


const ListCertificationSettings = Loadable(lazy(() => import('modules/core/certification/setting/ListCertificationSettings')));
const ListCertificationIssues = Loadable(lazy(() => import('modules/core/certification/issue/ListCertificationIssues')));

const ListBatches = Loadable(lazy(() => import('modules/core/batch/ListBatches')));
const ListMyBatches = Loadable(lazy(() => import('modules/core/batch/ListMyBatches')));
const ListMeetings = Loadable(lazy(() => import('modules/core/meeting/ListMeetings')));
const ListGroups = Loadable(lazy(() => import('modules/core/group/ListGroups')));
const ListGroupParticipants = Loadable(lazy(() => import('modules/core/group/group_participant/ListGroupParticipants')));
const ListGroupActivities = Loadable(lazy(() => import('modules/core/group/group_activity/ListGroupActivities')));
const ListMyGroups = Loadable(lazy(() => import('modules/core/group/ListMyGroups')));

const ListCompanies = Loadable(lazy(() => import('modules/hr/company/ListCompanies')));
const ListLearners = Loadable(lazy(() => import('modules/hr/learner/ListLearners')));
const ListTrainers = Loadable(lazy(() => import('modules/hr/trainer/ListTrainers')));
const ListSponsors = Loadable(lazy(() => import('modules/hr/sponsor/ListSponsors')));

const ListEmployees = Loadable(lazy(() => import('modules/hr/employee/ListEmployees')));
const ListRoles = Loadable(lazy(() => import('modules/hr/role/ListRoles')));
const ViewProfile = Loadable(lazy(() => import('modules/hr/profile/ViewProfile')));

const ViewGeneral = Loadable(lazy(() => import('modules/settings/general/ViewGeneral')));
const ListBackups = Loadable(lazy(() => import('modules/settings/backup/ListBackups')));
const ListDataUpdates = Loadable(lazy(() => import('modules/settings/dataUpdate/ListDataUpdates')));

const ListAssessmentCriterias = Loadable(lazy(() => import('modules/settings/assessmentCriteria/ListAssessmentCriterias')));
const ListDepartments = Loadable(lazy(() => import('modules/settings/department/ListDepartments')));
const ListJobTitles = Loadable(lazy(() => import('modules/settings/job_title/ListJobTitles')));
const ListBranches = Loadable(lazy(() => import('modules/settings/branch/ListBranches')));
const ListTrainingLocations = Loadable(lazy(() => import('modules/settings/trainingLocation/ListTrainingLocations')));

const ListPaymentMethods = Loadable(lazy(() => import('modules/settings/payment_method/ListPaymentMethods')));
const ListCurrencies = Loadable(lazy(() => import('modules/settings/currency/ListCurrencies')));

const ListCertificationTypes = Loadable(lazy(() => import('modules/settings/certification_type/ListCertificationTypes')));
const ListEducationTypes = Loadable(lazy(() => import('modules/settings/education_type/ListEducationTypes')));
const ListMembershipTypes = Loadable(lazy(() => import('modules/settings/membership_type/ListMembershipTypes')));
const ListExperienceTypes = Loadable(lazy(() => import('modules/settings/experience_type/ListExperienceTypes')));
const ListCpdActivityTypes = Loadable(lazy(() => import('modules/settings/cpd_activity_type/ListCpdActivityTypes')));
const ListCpdYearTargets = Loadable(lazy(() => import('modules/settings/cpd_year_target/ListCpdYearTargets')));

const ListAnswerTypes = Loadable(lazy(() => import('modules/settings/answer_type/ListAnswerTypes')));
const ListQuestionTypes = Loadable(lazy(() => import('modules/settings/question_type/ListQuestionTypes')));
const ListExamTypes = Loadable(lazy(() => import('modules/settings/exam_type/ListExamTypes')));

const ListSupportTypes = Loadable(lazy(() => import('modules/settings/support_type/ListSupportTypes')));
const ListSupportTicketResponses = Loadable(lazy(() => import('modules/settings/support_ticket_response/ListSupportTicketResponses')));

const ListCourseTypes = Loadable(lazy(() => import('modules/settings/course_type/ListCourseTypes')));
const ListAwardingBodies = Loadable(lazy(() => import('modules/settings/awarding_body/ListAwardingBodies')));
const ListManagementLevels = Loadable(lazy(() => import('modules/settings/management_level/ListManagementLevels')));
const ListDeliveryOptions = Loadable(lazy(() => import('modules/settings/delivery_option/ListDeliveryOptions')));
const ListDeliveryPatterns = Loadable(lazy(() => import('modules/settings/delivery_pattern/ListDeliveryPatterns')));
const ListContentTypes = Loadable(lazy(() => import('modules/settings/content_type/ListContentTypes')));

const ListDynamicButtons = Loadable(lazy(() => import('modules/settings/dynamic_button/ListDynamicButtons')));

const ListMeetingTypes = Loadable(lazy(() => import('modules/settings/meeting_type/ListMeetingTypes')));
const ListMandatoryAgendas = Loadable(lazy(() => import('modules/settings/mandatory_agenda/ListMandatoryAgendas')));
const ListModeOfCommunications = Loadable(lazy(() => import('modules/settings/mode_of_communication/ListModeOfCommunications')));
const ListFrequencyOfMeetings = Loadable(lazy(() => import('modules/settings/frequency_of_meeting/ListFrequencyOfMeetings')));

const ListCategories = Loadable(lazy(() => import('modules/settings/category/ListCategories')));
const ListIndustries = Loadable(lazy(() => import('modules/settings/industry/ListIndustries')));

const ListSupportTickets = Loadable(lazy(() => import('modules/support/ListSupportTickets')));
const ShowChatBot = Loadable(lazy(() => import('modules/support/ShowChatBot')));
const ViewSupportTicket = Loadable(lazy(() => import('modules/support/ViewSupportTicket')));

const TakeExam = Loadable(lazy(() => import('modules/core/exam/take/TakeExam')));

const ListGeneratedReports = Loadable(lazy(() => import('modules/core/report/generated_report/ListGeneratedReports')));
const ListScheduledReports = Loadable(lazy(() => import('modules/core/report/scheduled_report/ListScheduledReports')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
	path: '/',
	children: [
		{
			path: '/',
			element: (
				<AuthGuard>
					<MainLayout />
				</AuthGuard>
			),
			children: [
				{
					path: 'dashboard',
					element: <DashboardDefault />
				},

				{
					path: 'dashboard',
					element: <DashboardDefault />
				},
				{
					path: 'app',
					children: [
						{
							path: '',
							children: [
								{
									path: 'profile/:profile_id',
									element: <ViewProfile />
								},
								{
									path: 'manage/course',
									element: <ListManageCourses />
								},
								{
									path: 'manage/courses/:course_id/manage/course',
									element: <ManageCourse />
								},
								{
									path: 'course/list/courses',
									element: <ListCourses />
								},
								{
									path: 'course/list/my/courses',
									element: <ListMyCourses />
								},
								{
									path: 'course/unit/view/:unit_id',
									element: <CourseUnitView />
								},
								{
									path: 'course/list/details/:course_id',
									element: <CourseDetail />
								},
								{
									path: 'course/list/courses/:course_id/view',
									element: <CourseView />
								},
								{
									path: 'course/list/courses/unit/chapter/:chapter_id/view',
									element: <CourseChapterView />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'batch',
							children: [
								{
									path: 'list/batches',
									element: <ListBatches />
								},
								{
									path: 'list/feedback/sessions',
									element: <ListFeedbackSessions />
								},
								{
									path: 'list/schedule/templates',
									element: <ListBatchScheduleTemplates />
								},
								{
									path: 'list/assessment/criteria/templates',
									element: <ListBatchAssessmentCriteriaTemplates />
								},
								{
									path: 'list/my/batches',
									element: <ListMyBatches />
								},
								{
									path: 'view/:batch_no',
									element: <ViewBatch />
									// element: <ViewBatchRecord />
								},
								{
									path: 'tabs/view/:batch_no',
									element: <ViewBatchRecord />
									// element: <ViewBatch />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'exam/bank',
							children: [
								{
									path: 'list/questions',
									element: <ListQuestions />
								},
								{
									path: 'list/exams',
									element: <ListExams />
								},
								{
									path: 'list/exams/retakes',
									element: <ListRetakeExams />
								},
								{
									path: 'question/templates',
									element: <ListExamQuestionTemplates />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'assignment',
							children: [
								{
									path: 'bank/list/assignments',
									element: <ListAssignments />
								},
								{
									path: 'bank/list/batch-assignments',
									element: <ListBatchAssignments />
								},
								{
									path: 'take/:batch_assignment_id',
									element: <TakeAssignment />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'certification',
							children: [
								{
									path: 'templates',
									element: <ListCertificationSettings />
								},
								{
									path: 'issue',
									element: <ListCertificationIssues />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'group',
							children: [
								{
									path: 'list/groups',
									element: <ListGroups />
								},
								{
									path: 'list/participants/:group_no',
									element: <ListGroupParticipants />
								},
								{
									path: 'list/activities/:group_no',
									element: <ListGroupActivities />
								},
								{
									path: 'list/my/groups',
									element: <ListMyGroups />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'meeting',
							children: [
								{
									path: 'list/meetings',
									element: <ListMeetings />
								},

								{
									path: '*',
									element: <Page404 />
								}
							]
						},

						{
							path: 'hr',
							children: [
								{
									path: 'employees',
									element: <ListEmployees />
								},
								{
									path: 'roles',
									element: <ListRoles />
								},
								{
									path: 'profile/:profile_id',
									element: <ViewProfile />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'users',
							children: [
								{
									path: 'companies',
									element: <ListCompanies />
								},
								{
									path: 'learners',
									element: <ListLearners />
								},
								{
									path: 'trainers',
									element: <ListTrainers />
								},
								{
									path: 'sponsors',
									element: <ListSponsors />
								},
								{
									path: 'profile/:profile_id',
									element: <ViewProfile />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'stats',
							children: [
								{
									path: 'learner',
									children: [
										{
											path: 'overall',
											// element: <PageUnderConstruction />
											element: <LearnerOverallReport />
										},
										{
											path: 'individual',
											// element: <PageUnderConstruction />
											element: <LearnerIndividualReport />
										},
										{
											path: 'iqa',
											element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'cpd',
									children: [
										{
											path: 'manage',
											element: <CpdRecordReport />
											// element: <PageUnderConstruction />
										},
										{
											path: 'record',
											element: <CpdRecord />
											// element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'course',
									children: [
										{
											path: 'all',
											element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'batch/stats',
									children: [
										{
											path: 'all',
											element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'group',
									children: [
										{
											path: 'all',
											element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'exam',
									children: [
										{
											path: 'all',
											element: <PageUnderConstruction />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'reports',
							children: [
								{
									path: 'lms',
									element: <ListDataUpdates />
								},
								{
									path: 'exam',
									element: <ExamReport />
									// element: <PageUnderConstruction />
								},
								{
									path: 'batch-assessment',
									element: <BatchAssessmentReport />
								},
								{
									path: 'batch',
									element: <PageUnderConstruction />
								},
								{
									path: 'learner',
									element: <PageUnderConstruction />
								},
								{
									path: 'trainer',
									element: <TrainerReport />
									// element: <PageUnderConstruction />
								},
								{
									path: 'attendance',
									element: <AttendanceReport />
									// element: <PageUnderConstruction />
								},
								{
									path: 'company/summary',
									element: <ListCompanySummaryReport />
									// element: <PageUnderConstruction />
								},
								{
									path: 'support',
									element: <SupportReport />
									// element: <PageUnderConstruction />
								},
								{
									path: 'course',
									children: [
										{
											path: 'progress',
											element: <BatchParticipantCourseProgressStats />
										}
									]
								},
								{
									path: 'certificate',
									children: [
										{
											path: 'report',
											// element: <PageUnderConstruction />
											element: <CertificateReport />
										},
										{
											path: 'verify',
											// element: <PageUnderConstruction />
											element: <CertificateVerify />
										},
										{
											path: 'missing',
											element: <CertificateMissing />
										}
									]
								},
								{
									path: 'feedback',
									children: [
										{
											path: 'report',
											element: <FeedbackReport />
										},
										{
											path: 'collection',
											element: <FeedbackReportCollection />
										},
										{
											path: 'review-system',
											element: <FeedbackReviewSystemReport />
										}
									]
								},
								{
									path: 'generated',
									element: <ListGeneratedReports />
								},
								{
									path: 'scheduled',
									element: <ListScheduledReports />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'settings',
							children: [
								{
									path: 'general',
									element: <ViewGeneral />
								},
								{
									path: 'backup',
									element: <ListBackups />
								},
								{
									path: 'dynamic/buttons',
									element: <ListDynamicButtons />
								},
								{
									path: 'custom/email/templates',
									element: <ListCustomEmailTemplates />
								},
								{
									path: 'hr',
									children: [
										{
											path: 'departments',
											element: <ListDepartments />
										},
										{
											path: 'job/titles',
											element: <ListJobTitles />
										},
										{
											path: 'branches',
											element: <ListBranches />
										},
										{
											path: 'training/locations',
											element: <ListTrainingLocations />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'finance',
									children: [
										{
											path: 'payment/methods',
											element: <ListPaymentMethods />
										},
										{
											path: 'currencies',
											element: <ListCurrencies />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'profile',
									children: [
										{
											path: 'certification/types',
											element: <ListCertificationTypes />
										},
										{
											path: 'education/types',
											element: <ListEducationTypes />
										},
										{
											path: 'membership/types',
											element: <ListMembershipTypes />
										},
										{
											path: 'experience/types',
											element: <ListExperienceTypes />
										},
										{
											path: 'activity/types',
											element: <ListCpdActivityTypes />
										},
										{
											path: 'year/targets',
											element: <ListCpdYearTargets />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'exam',
									children: [
										{
											path: 'types',
											element: <ListExamTypes />
										},
										{
											path: 'answer/types',
											element: <ListAnswerTypes />
										},
										{
											path: 'question/types',
											element: <ListQuestionTypes />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'assessment',
									children: [
										{
											path: 'criterias',
											element: <ListAssessmentCriterias />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'course',
									children: [
										{
											path: 'types',
											element: <ListCourseTypes />
										},
										{
											path: 'content/types',
											element: <ListContentTypes />
										},
										{
											path: 'awarding/bodies',
											element: <ListAwardingBodies />
										},
										{
											path: 'management/levels',
											element: <ListManagementLevels />
										},
										{
											path: 'delivery/options',
											element: <ListDeliveryOptions />
										},
										{
											path: 'delivery/patterns',
											element: <ListDeliveryPatterns />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: '', //meeting
									children: [
										{
											path: 'meeting/types',
											element: <ListMeetingTypes />
										},
										{
											path: 'mandatory/agendas',
											element: <ListMandatoryAgendas />
										},
										{
											path: 'mode/of/communication',
											element: <ListModeOfCommunications />
										},
										{
											path: 'frequency/of/meeting',
											element: <ListFrequencyOfMeetings />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'core',
									children: [
										{
											path: 'categories',
											element: <ListCategories />
										},
										{
											path: 'industries',
											element: <ListIndustries />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: 'support',
									children: [
										{
											path: 'types',
											element: <ListSupportTypes />
										},
										{
											path: 'responses',
											element: <ListSupportTicketResponses />
										},
										{
											path: '*',
											element: <Page404 />
										}
									]
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: 'support',
							children: [
								{
									path: 'feedback-review-system',
									element: <ListFeedbackReviewSystems />
								},
								{
									path: 'tickets',
									element: <ListSupportTickets />
								},
								{
									path: 'chatbot',
									element: <ShowChatBot />
								},
								{
									path: 'tickets/:no/view',
									element: <ViewSupportTicket />
								},
								{
									path: '*',
									element: <Page404 />
								}
							]
						},
						{
							path: '*',
							element: <Page404 />
						}
					]
				},

				{
					path: '*',
					element: <Page404 />
				}
			]
		},
		{
			path: '/',
			element: (
				<AuthGuard>
					<CommonLayout />
				</AuthGuard>
			),
			children: [
				{
					path: 'app',
					children: [
						{
							path: 'change-password',
							element: <ChangePasswordWrapper />
						},
						{
							path: 'change-record',
							element: <ChangeRecordWrapper />
						},
						{
							path: 'trainer-report-all-time',
							element: <TrainerReportAllTimeWrapper />
						},
						{
							path: 'exam/:exam_no/take',
							element: <TakeExam />
						},
						{
							path: 'course/chapter/:chapter_id/view',
							element: <CourseChapterViewSimple />
						},
						{
							path: 'attendance/QR/:related_type?/:related_id?',
							element: <ViewAttendanceQR />
						},
						{
							path: 'attendance/scan/QR',
							element: <ScanAttendanceQR />
						},
						{
							path: '*',
							element: <Page404 />
						}
					]
				},
				{
					path: 'terms/service',
					children: [
						{
							path: 'ar',
							element: <TermsServiceAr />
						},
						{
							path: 'en',
							element: <TermsServiceEn />
						}
					]
				},
				{
					path: 'privacy/policy',
					children: [
						{
							path: 'ar',
							element: <PrivacyPolicyAr />
						},
						{
							path: 'en',
							element: <PrivacyPolicyEn />
						}
					]
				},
				{
					path: '*',
					element: <Page404 />
				}
			]
		}
	]
};

export default MainRoutes;
